/**
 * 悬浮按钮集合
 */
import React, { FC, useEffect, useMemo } from 'react'
import { BuyTogetherBar, CouponBar, ThirdCouponBar } from '../'
import { buyTogetherMobx, memberMobx, multiPersonMobx } from '@mobxStore'
import { observer } from 'mobx-react'
import './index.scss'

// interface
interface IProps { }

const BTAndCouponBar: FC<IProps> = () => {
  // 是否有优惠券
  const hasCoupon = useMemo(() => {
    return memberMobx.isLogin && memberMobx.couponList?.length
  }, [memberMobx.isLogin, memberMobx.couponList?.length])
  // 拼单不展示
  const showCoupon = !Config.buyTogetherId || Config.buyTogetherId && multiPersonMobx.getCurrentPersonInfo().isOwner
  const showTCoupon = showCoupon && !(buyTogetherMobx.canStartBuyTogether && hasCoupon)
  return (
    <div className='coupon-buyTogether-btn-wrapper'>
      {
        showCoupon && <CouponBar showTC={!showTCoupon} />
      }
      {
        showTCoupon && <ThirdCouponBar />
      }
      <BuyTogetherBar />
    </div>
  )
}
export default observer(BTAndCouponBar)
